import { Guid, IApiLink } from "@/types"

export interface IProductLineDTO {
    id: Guid
    description?: string
    links: IApiLink[]
}

export interface IProductLine {
    id: Guid
    description?: string
}

export default class ProductLine implements IProductLine {
    constructor(
        public id: Guid,
        public description?: string,
    ) {}
}
